import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { KeywordExplorerPage } from './pages/KeywordExplorerPage';
import { PinGeneratorPage } from './pages/PinGeneratorPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { SchedulerPage } from './pages/SchedulerPage';
import { LinkExplorerPage } from './pages/LinkExplorerPage';
import { TopPinsPage } from './pages/TopPinsPage';
import { PinStatsPage } from './pages/PinStatsPage';
import { SavedPinsPage } from './pages/SavedPinsPage';
import { RankTrackerPage } from './pages/RankTrackerPage';
import { SearchTrackerPage } from './pages/SearchTrackerPage';
import { SavedKeywordsPage } from './pages/SavedKeywordsPage';
import { AccountExplorerPage } from './pages/AccountExplorerPage';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/keyword-explorer" replace />} />
        <Route path="/keyword-explorer" element={<KeywordExplorerPage />} />
        <Route path="/pin-generator" element={<PinGeneratorPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/scheduler" element={<SchedulerPage />} />
        <Route path="/link-explorer" element={<LinkExplorerPage />} />
        <Route path="/top-pins" element={<TopPinsPage />} />
        <Route path="/pin-stats" element={<PinStatsPage />} />
        <Route path="/saved-pins" element={<SavedPinsPage />} />
        <Route path="/rank-tracker" element={<RankTrackerPage />} />
        <Route path="/search-tracker" element={<SearchTrackerPage />} />
        <Route path="/saved-keywords" element={<SavedKeywordsPage />} />
        <Route path="/account-explorer" element={<AccountExplorerPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
